module.exports = __webpack_public_path__ + "img/37.ab064fd5.png";